import { render } from "./TheScheme.vue?vue&type=template&id=72ec225c&scoped=true"
import script from "./TheScheme.vue?vue&type=script&lang=js"
export * from "./TheScheme.vue?vue&type=script&lang=js"

import "./TheScheme.vue?vue&type=style&index=0&id=72ec225c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ec225c"]])

export default __exports__